import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AngularFireAuth } from '@angular/fire/auth';
import { PeopleService } from '../services/people.service';
import { Observable } from 'rxjs';


@Injectable()
export class AuthGuard implements CanActivate {
  user = {
    role: 'admin'
  }

  constructor(
    public auth: AngularFireAuth,
    public userService: PeopleService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if(false){
        return true;
      }
      else{
        this.router.navigate(['user/login'])
        return false
      }
    }
  
  

  // canActivate(): Promise<boolean>{
  //   return new Promise((resolve, reject) => {
  //     this.userService.getCurrentUser()
  //     .then(user => {
  //       this.router.navigate(['user/profile']);
  //       return resolve(false);
  //     }, err => {
  //       return resolve(true);
  //     })
  //   })
  // }

}